import Spinner from "@/ui/core/Spinner";
import { VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

// Absolute-positioned overlay with an opaque background so an underlying
// WebView/iframe's own loading spinner can't bleed through and show double spinner
const OpaqueSpinnerOverlay = () => {
  return (
    <VStack
      backgroundColor={ColorToken.NeutralBackgroundPrimary}
      height="100%"
      justifyContent="center"
      position="absolute"
      width="100%"
    >
      <Spinner />
    </VStack>
  );
};

export default OpaqueSpinnerOverlay;
